import { ExpandCollapseAnimation } from '@doltech/ui/lib/examples/Animation/ExpandCollapse';
import { TestTypeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import styled from 'styled-components';
import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { QuestionBar } from '../QuestionBar';
import { ButtonQuestionNavigation } from './ButtonQuestionNavigation';
import { PracticeTestReadingBottomNavigation } from './LayoutModePracticeTest/PracticeTestReadingBottomNavigation';

const Main = styled.div`
  display: grid;
  grid-template-columns: 184px minmax(0px, 1fr) 184px;
  padding: 10px 16px;
  box-shadow: inset 0 1px 0 ${colorsV2.gray10};
  width: 100%;
  overflow: hidden;

  .section-middle {
    display: flex;
    justify-content: center;
  }
`;

const Container = styled.div`
  background-color: ${colorsV2.white100};
  z-index: 1;
  bottom: 0;
  box-shadow: inset 0 1px 0 ${colorsV2.gray10};
`;

const QuestionBarWrapper = styled.div`
  height: 56px;
  background-color: ${colorsV2.white100};
  display: flex;
  padding: 0 16px;
  justify-content: center;
`;

interface BottomNavigationProps extends React.HTMLAttributes<HTMLDivElement> {
  disableTestInfo?: boolean;
  disableSubmitAction?: boolean;
  onSubmitWithEvents?: () => void;
}

export const SectionInfo = observer((props: BottomNavigationProps) => {
  const { disableTestInfo, disableSubmitAction, onSubmitWithEvents, children } = props;

  if (disableTestInfo) {
    return (
      <div className="all-section-info reading-view-only">
        <div className="section-right">
          <ButtonQuestionNavigation
            disableSubmitAction={disableSubmitAction}
            onSubmitWithEvents={onSubmitWithEvents}
            enableEvent
          />
        </div>
      </div>
    );
  }
  return (
    <Main>
      <div />
      <div className="section-middle">{children}</div>
      <div className="section-right">
        <ButtonQuestionNavigation
          disableSubmitAction={disableSubmitAction}
          onSubmitWithEvents={onSubmitWithEvents}
          enableEvent
        />
      </div>
    </Main>
  );
});

export const ReadingBottomNavigation = observer((props: BottomNavigationProps) => {
  const { children, disableTestInfo, disableSubmitAction, onSubmitWithEvents } = props;
  const store = useTestSubmissionStore();

  switch (store.testType) {
    case TestTypeEnum.PRACTICE_TEST: {
      return <PracticeTestReadingBottomNavigation onSubmitWithEvents={onSubmitWithEvents} />;
    }
    case TestTypeEnum.FULL_TEST:
    default:
  }
  return (
    <Container>
      <ExpandCollapseAnimation expanded={store.bottomNavigationExpanded}>
        <QuestionBarWrapper>
          <QuestionBar />
        </QuestionBarWrapper>
      </ExpandCollapseAnimation>

      <SectionInfo
        disableTestInfo={disableTestInfo}
        disableSubmitAction={disableSubmitAction}
        onSubmitWithEvents={onSubmitWithEvents}
      >
        {children}
      </SectionInfo>
    </Container>
  );
});
